export default {
  computed: {
    $typeAheadAboutsLanguage() {
      return [
        {
          value: null,
          text: "Please select your Language",
          localization: null
        },
        {
          value: "ab",
          text: "Abkhaz",
          localization: "аҧсуа"
        },
        {
          value: "aa",
          text: "Afar",
          localization: "Afaraf"
        },
        {
          value: "af",
          text: "Afrikaans",
          localization: "Afrikaans"
        },
        {
          value: "ak",
          text: "Akan",
          localization: "Akan"
        },
        {
          value: "sq",
          text: "Albanian",
          localization: "Shqip"
        },
        {
          value: "am",
          text: "Amharic",
          localization: "አማርኛ"
        },
        {
          value: "ar",
          text: "Arabic",
          localization: "العربية"
        },
        {
          value: "an",
          text: "Aragonese",
          localization: "Aragonés"
        },
        {
          value: "hy",
          text: "Armenian",
          localization: "Հայերեն"
        },
        {
          value: "as",
          text: "Assamese",
          localization: "অসমীয়া"
        },
        {
          value: "av",
          text: "Avaric",
          localization: "авар мацӀ, магӀарул мацӀ"
        },
        {
          value: "ae",
          text: "Avestan",
          localization: "avesta"
        },
        {
          value: "ay",
          text: "Aymara",
          localization: "aymar aru"
        },
        {
          value: "az",
          text: "Azerbaijani",
          localization: "azərbaycan dili"
        },
        {
          value: "bm",
          text: "Bambara",
          localization: "bamanankan"
        },
        {
          value: "ba",
          text: "Bashkir",
          localization: "башҡорт теле"
        },
        {
          value: "eu",
          text: "Basque",
          localization: "euskara, euskera"
        },
        {
          value: "be",
          text: "Belarusian",
          localization: "Беларуская"
        },
        {
          value: "bn",
          text: "Bengali",
          localization: "বাংলা"
        },
        {
          value: "bh",
          text: "Bihari",
          localization: "भोजपुरी"
        },
        {
          value: "bi",
          text: "Bislama",
          localization: "Bislama"
        },
        {
          value: "bs",
          text: "Bosnian",
          localization: "bosanski jezik"
        },
        {
          value: "br",
          text: "Breton",
          localization: "brezhoneg"
        },
        {
          value: "bq",
          text: "Bulgarian",
          localization: "български език"
        },
        {
          value: "my",
          text: "Burmese",
          localization: "ဗမာစာ"
        },
        {
          value: "ca",
          text: "Catalan; Valencian",
          localization: "Català"
        },
        {
          value: "ch",
          text: "Chamorro",
          localization: "Chamoru"
        },
        {
          value: "ce",
          text: "Chechen",
          localization: "нохчийн мотт"
        },
        {
          value: "localization",
          text: "Chichewa; Chewa; Nyanja",
          localization: "chiCheŵa, chinyanja"
        },
        {
          value: "zh",
          text: "Chinese",
          localization: "中文 (Zhōngwén), 汉语, 漢語"
        },
        {
          value: "cv",
          text: "Chuvash",
          localization: "чӑваш чӗлхи"
        },
        {
          value: "kw",
          text: "Cornish",
          localization: "Kernewek"
        },
        {
          value: "co",
          text: "Corsican",
          localization: "corsu, lingua corsa"
        },
        {
          value: "cr",
          text: "Cree",
          localization: "ᓀᐦᐃᔭᐍᐏᐣ"
        },
        {
          value: "hr",
          text: "Croatian",
          localization: "hrvatski"
        },
        {
          value: "cs",
          text: "Czech",
          localization: "česky, čeština"
        },
        {
          value: "da",
          text: "Danish",
          localization: "dansk"
        },
        {
          value: "dv",
          text: "Divehi; Dhivehi; Maldivian;",
          localization: "ދިވެހި"
        },
        {
          value: "nl",
          text: "Dutch",
          localization: "Nederlands, Vlaams"
        },
        {
          value: "en",
          text: "English",
          localization: "English"
        },
        {
          value: "eo",
          text: "Esperanto",
          localization: "Esperanto"
        },
        {
          value: "et",
          text: "Estonian",
          localization: "eesti, eesti keel"
        },
        {
          value: "ee",
          text: "Ewe",
          localization: "Eʋegbe"
        },
        {
          value: "fo",
          text: "Faroese",
          localization: "føroyskt"
        },
        {
          value: "fj",
          text: "Fijian",
          localization: "vosa Vakaviti"
        },
        {
          value: "fi",
          text: "Finnish",
          localization: "suomi, suomen kieli"
        },
        {
          value: "fr",
          text: "French",
          localization: "français, langue française"
        },
        {
          value: "ff",
          text: "Fula; Fulah; Pulaar; Pular",
          localization: "Fulfulde, Pulaar, Pular"
        },
        {
          value: "gl",
          text: "Galician",
          localization: "Galego"
        },
        {
          value: "ka",
          text: "Georgian",
          localization: "ქართული"
        },
        {
          value: "de",
          text: "German",
          localization: "Deutsch"
        },
        {
          value: "el",
          text: "Greek, Modern",
          localization: "Ελληνικά"
        },
        {
          value: "gn",
          text: "Guaraní",
          localization: "Avañeẽ"
        },
        {
          value: "gu",
          text: "Gujarati",
          localization: "ગુજરાતી"
        },
        {
          value: "ht",
          text: "Haitian; Haitian Creole",
          localization: "Kreyòl ayisyen"
        },
        {
          value: "ha",
          text: "Hausa",
          localization: "Hausa, هَوُسَ"
        },
        {
          value: "he",
          text: "Hebrew (modern)",
          localization: "עברית"
        },
        {
          value: "hz",
          text: "Herero",
          localization: "Otjiherero"
        },
        {
          value: "hi",
          text: "Hindi",
          localization: "हिन्दी, हिंदी"
        },
        {
          value: "ho",
          text: "Hiri Motu",
          localization: "Hiri Motu"
        },
        {
          value: "hu",
          text: "Hungarian",
          localization: "Magyar"
        },
        {
          value: "ia",
          text: "Interlingua",
          localization: "Interlingua"
        },
        {
          value: "id",
          text: "Indonesian",
          localization: "Bahasa Indonesia"
        },
        {
          value: "ie",
          text: "Interlingue",
          localization:
            "Originally called Occidental; then Interlingue after WWII"
        },
        {
          value: "ga",
          text: "Irish",
          localization: "Gaeilge"
        },
        {
          value: "ig",
          text: "Igbo",
          localization: "Asụsụ Igbo"
        },
        {
          value: "ik",
          text: "Inupiaq",
          localization: "Iñupiaq, Iñupiatun"
        },
        {
          value: "io",
          text: "Ido",
          localization: "Ido"
        },
        {
          value: "is",
          text: "Icelandic",
          localization: "Íslenska"
        },
        {
          value: "it",
          text: "Italian",
          localization: "Italiano"
        },
        {
          value: "iu",
          text: "Inuktitut",
          localization: "ᐃᓄᒃᑎᑐᑦ"
        },
        {
          value: "ja",
          text: "Japanese",
          localization: "日本語 (にほんご／にっぽんご)"
        },
        {
          value: "jv",
          text: "Javanese",
          localization: "basa Jawa"
        },
        {
          value: "kl",
          text: "Kalaallisut, Greenlandic",
          localization: "kalaallisut, kalaallit oqaasii"
        },
        {
          value: "kn",
          text: "Kannada",
          localization: "ಕನ್ನಡ"
        },
        {
          value: "kr",
          text: "Kanuri",
          localization: "Kanuri"
        },
        {
          value: "ks",
          text: "Kashmiri",
          localization: "कश्मीरी, كشميري‎"
        },
        {
          value: "kk",
          text: "Kazakh",
          localization: "Қазақ тілі"
        },
        {
          value: "km",
          text: "Khmer",
          localization: "ភាសាខ្មែរ"
        },
        {
          value: "ki",
          text: "Kikuyu, Gikuyu",
          localization: "Gĩkũyũ"
        },
        {
          value: "rw",
          text: "Kinyarwanda",
          localization: "Ikinyarwanda"
        },
        {
          value: "ky",
          text: "Kirghiz, Kyrgyz",
          localization: "кыргыз тили"
        },
        {
          value: "kv",
          text: "Komi",
          localization: "коми кыв"
        },
        {
          value: "kg",
          text: "Kongo",
          localization: "KiKongo"
        },
        {
          value: "ko",
          text: "Korean",
          localization: "한국어 (韓國語), 조선말 (朝鮮語)"
        },
        {
          value: "ku",
          text: "Kurdish",
          localization: "Kurdî, كوردی‎"
        },
        {
          value: "kj",
          text: "Kwanyama, Kuanyama",
          localization: "Kuanyama"
        },
        {
          value: "la",
          text: "Latin",
          localization: "latine, lingua latina"
        },
        {
          value: "lb",
          text: "Luxembourgish, Letzeburgesch",
          localization: "Lëtzebuergesch"
        },
        {
          value: "lg",
          text: "Luganda",
          localization: "Luganda"
        },
        {
          value: "li",
          text: "Limburgish, Limburgan, Limburger",
          localization: "Limburgs"
        },
        {
          value: "ln",
          text: "Lingala",
          localization: "Lingála"
        },
        {
          value: "lo",
          text: "Lao",
          localization: "ພາສາລາວ"
        },
        {
          value: "lt",
          text: "Lithuanian",
          localization: "lietuvių kalba"
        },
        {
          value: "lu",
          text: "Luba-Katanga",
          localization: ""
        },
        {
          value: "lv",
          text: "Latvian",
          localization: "latviešu valoda"
        },
        {
          value: "gv",
          text: "Manx",
          localization: "Gaelg, Gailck"
        },
        {
          value: "mk",
          text: "Macedonian",
          localization: "македонски јазик"
        },
        {
          value: "localization",
          text: "Malagasy",
          localization: "Malagasy fiteny"
        },
        {
          value: "ms",
          text: "Malay",
          localization: "bahasa Melayu, بهاس ملايو‎"
        },
        {
          value: "ml",
          text: "Malayalam",
          localization: "മലയാളം"
        },
        {
          value: "mt",
          text: "Maltese",
          localization: "Malti"
        },
        {
          value: "mi",
          text: "Māori",
          localization: "te reo Māori"
        },
        {
          value: "mr",
          text: "Marathi (Marāṭhī)",
          localization: "मराठी"
        },
        {
          value: "mh",
          text: "Marshallese",
          localization: "Kajin M̧ajeļ"
        },
        {
          value: "mn",
          text: "Mongolian",
          localization: "монгол"
        },
        {
          value: "na",
          text: "Nauru",
          localization: "Ekakairũ Naoero"
        },
        {
          value: "nv",
          text: "Navajo, Navaho",
          localization: "Diné bizaad, Dinékʼehǰí"
        },
        {
          value: "nb",
          text: "Norwegian Bokmål",
          localization: "Norsk bokmål"
        },
        {
          value: "nd",
          text: "North Ndebele",
          localization: "isiNdebele"
        },
        {
          value: "ne",
          text: "Nepali",
          localization: "नेपाली"
        },
        {
          value: "ng",
          text: "Ndonga",
          localization: "Owambo"
        },
        {
          value: "nn",
          text: "Norwegian Nynorsk",
          localization: "Norsk nynorsk"
        },
        {
          value: "tenoxt",
          text: "Norwegian",
          localization: "Norsk"
        },
        {
          value: "ii",
          text: "Nuosu",
          localization: "ꆈꌠ꒿ Nuosuhxop"
        },
        {
          value: "nr",
          text: "South Ndebele",
          localization: "isiNdebele"
        },
        {
          value: "oc",
          text: "Occitan",
          localization: "Occitan"
        },
        {
          value: "oj",
          text: "Ojibwe, Ojibwa",
          localization: "ᐊᓂᔑᓈᐯᒧᐎᓐ"
        },
        {
          value: "cu",
          text:
            "Old Church Slavonic, Church Slavic, Church Slavonic, Old Bulgarian, Old Slavonic",
          localization: "ѩзыкъ словѣньскъ"
        },
        {
          value: "om",
          text: "Oromo",
          localization: "Afaan Oromoo"
        },
        {
          value: "or",
          text: "Oriya",
          localization: "ଓଡ଼ିଆ"
        },
        {
          value: "os",
          text: "Ossetian, Ossetic",
          localization: "ирон æвзаг"
        },
        {
          value: "pa",
          text: "Panjabi, Punjabi",
          localization: "ਪੰਜਾਬੀ, پنجابی‎"
        },
        {
          value: "pi",
          text: "Pāli",
          localization: "पाऴि"
        },
        {
          value: "fa",
          text: "Persian",
          localization: "فارسی"
        },
        {
          value: "pl",
          text: "Polish",
          localization: "polski"
        },
        {
          value: "ps",
          text: "Pashto, Pushto",
          localization: "پښتو"
        },
        {
          value: "pt",
          text: "Portuguese",
          localization: "Português"
        },
        {
          value: "qu",
          text: "Quechua",
          localization: "Runa Simi, Kichwa"
        },
        {
          value: "rm",
          text: "Romansh",
          localization: "rumantsch grischun"
        },
        {
          value: "rn",
          text: "Kirundi",
          localization: "kiRundi"
        },
        {
          value: "ro",
          text: "Romanian, Moldavian, Moldovan",
          localization: "română"
        },
        {
          value: "ru",
          text: "Russian",
          localization: "русский язык"
        },
        {
          value: "sa",
          text: "Sanskrit (Saṁskṛta)",
          localization: "संस्कृतम्"
        },
        {
          value: "sc",
          text: "Sardinian",
          localization: "sardu"
        },
        {
          value: "sd",
          text: "Sindhi",
          localization: "सिन्धी, سنڌي، سندھی‎"
        },
        {
          value: "se",
          text: "Northern Sami",
          localization: "Davvisámegiella"
        },
        {
          value: "sm",
          text: "Samoan",
          localization: "gagana faa Samoa"
        },
        {
          value: "sq",
          text: "Sango",
          localization: "yângâ tî sängö"
        },
        {
          value: "sr",
          text: "Serbian",
          localization: "српски језик"
        },
        {
          value: "gd",
          text: "Scottish Gaelic; Gaelic",
          localization: "Gàidhlig"
        },
        {
          value: "sn",
          text: "Shona",
          localization: "chiShona"
        },
        {
          value: "si",
          text: "Sinhala, Sinhalese",
          localization: "සිංහල"
        },
        {
          value: "sk",
          text: "Slovak",
          localization: "slovenčina"
        },
        {
          value: "sl",
          text: "Slovene",
          localization: "slovenščina"
        },
        {
          value: "so",
          text: "Somali",
          localization: "Soomaaliga, af Soomaali"
        },
        {
          value: "st",
          text: "Southern Sotho",
          localization: "Sesotho"
        },
        {
          value: "es",
          text: "Spanish; Castilian",
          localization: "español, castellano"
        },
        {
          value: "su",
          text: "Sundanese",
          localization: "Basa Sunda"
        },
        {
          value: "sw",
          text: "Swahili",
          localization: "Kiswahili"
        },
        {
          value: "ss",
          text: "Swati",
          localization: "SiSwati"
        },
        {
          value: "sv",
          text: "Swedish",
          localization: "svenska"
        },
        {
          value: "ta",
          text: "Tamil",
          localization: "தமிழ்"
        },
        {
          value: "te",
          text: "Telugu",
          localization: "తెలుగు"
        },
        {
          value: "tq",
          text: "Tajik",
          localization: "тоҷикӣ, toğikī, تاجیکی‎"
        },
        {
          value: "th",
          text: "Thai",
          localization: "ไทย"
        },
        {
          value: "ti",
          text: "Tigrinya",
          localization: "ትግርኛ"
        },
        {
          value: "bo",
          text: "Tibetan Standard, Tibetan, Central",
          localization: "བོད་ཡིག"
        },
        {
          value: "tk",
          text: "Turkmen",
          localization: "Türkmen, Түркмен"
        },
        {
          value: "tl",
          text: "Tagalog",
          localization: "Wikang Tagalog, ᜏᜒᜃᜅ᜔ ᜆᜄᜎᜓᜄ᜔"
        },
        {
          value: "tn",
          text: "Tswana",
          localization: "Setswana"
        },
        {
          value: "to",
          text: "Tonga (Tonga Islands)",
          localization: "faka Tonga"
        },
        {
          value: "tr",
          text: "Turkish",
          localization: "Türkçe"
        },
        {
          value: "ts",
          text: "Tsonga",
          localization: "Xitsonga"
        },
        {
          value: "tt",
          text: "Tatar",
          localization: "татарча, tatarça, تاتارچا‎"
        },
        {
          value: "tw",
          text: "Twi",
          localization: "Twi"
        },
        {
          value: "ty",
          text: "Tahitian",
          localization: "Reo Tahiti"
        },
        {
          value: "ug",
          text: "Uighur, Uyghur",
          localization: "Uyƣurqə, ئۇيغۇرچە‎"
        },
        {
          value: "uk",
          text: "Ukrainian",
          localization: "українська"
        },
        {
          value: "ur",
          text: "Urdu",
          localization: "اردو"
        },
        {
          value: "uz",
          text: "Uzbek",
          localization: "zbek, Ўзбек, أۇزبېك‎"
        },
        {
          value: "ve",
          text: "Venda",
          localization: "Tshivenḓa"
        },
        {
          value: "vi",
          text: "Vietnamese",
          localization: "Tiếng Việt"
        },
        {
          value: "vo",
          text: "Volapük",
          localization: "Volapük"
        },
        {
          value: "wa",
          text: "Walloon",
          localization: "Walon"
        },
        {
          value: "cy",
          text: "Welsh",
          localization: "Cymraeg"
        },
        {
          value: "wo",
          text: "Wolof",
          localization: "Wollof"
        },
        {
          value: "fy",
          text: "Western Frisian",
          localization: "Frysk"
        },
        {
          value: "xh",
          text: "Xhosa",
          localization: "isiXhosa"
        },
        {
          value: "yi",
          text: "Yiddish",
          localization: "ייִדיש"
        },
        {
          value: "yo",
          text: "Yoruba",
          localization: "Yorùbá"
        },
        {
          value: "za",
          text: "Zhuang, Chuang",
          localization: "Saɯ cueŋƅ, Saw cuengh"
        }
      ];
    }
  }
};
